import { GET_ALL_CENTROS_DE_CUSTO } from './mutation-types'
import relatoriosHttpService from '../services/relatoriosHttpService'

export default {
  buscarCentroDeCustosNaApi: async ({ commit }) => {
    try {
      const response = await relatoriosHttpService.getCentrosDeCusto()
      commit(GET_ALL_CENTROS_DE_CUSTO, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
